<div class="rouded-form">
  <form [formGroup]="userForm" (ngSubmit)="submit()" autocomplete="off">
    <h3>{{title}}</h3>
    <h5>{{subtitle}}</h5>
    <div class="row">
      <div class="form-group col-5">
        <label for="gender" class="required">Civilité</label>
        <div class="form-group-select">
          <select id="gender"
            name="gender"
            [formControl]="gender"
            class="form-control">
            <option [ngValue]="1" selected>M.</option>
            <option [ngValue]="2">Mme</option>
          </select>
          <i class="bar"></i>
          <i class="dsicon-chevron-bas"></i>
        </div>
      </div>
      <div class="form-group col-7 form-nom">
        <label for="nom" class="required">Nom</label>
        <input type="text"
          id="nom"
          name="nom"
          [formControl]="nom"
          appTextTransform
          text-uppercase
          class="form-control">
        <i class="bar"></i>
        @if (nom.invalid && (nom.dirty || nom.touched)) {
          <span
          class="error">{{requiredAlert}} nom.</span>
        }
      </div>
      <div class="form-group col-12">
        <label for="prenom" class="required">Prénom</label>
        <input type="text"
          id="prenom"
          name="prenom"
          [formControl]="prenom"
          appTextTransform
          class="form-control">
        <i class="bar"></i>
        @if (prenom.invalid && (prenom.dirty || prenom.touched)) {
          <span
          class="error">{{requiredAlert}} prénom.</span>
        }
      </div>
      <div class="form-group col-12">
        <label for="email" class="required">Email</label>
        <input type="email"
          id="email"
          name="email"
          [formControl]="email"
          autocomplete="off"
          class="form-control">
        <i class="bar"></i>
        @if (email.invalid && (email.dirty || email.touched)) {
          <span
          class="error">{{requiredAlert}}e adresse mail valide</span>
        }
      </div>
      <div class="form-group col-12">
        <label for="password" class="required">Mot de passe</label>
        <input type="password"
          id="password"
          name="password"
          [formControl]="password"
          class="form-control">
        <i class="bar"></i>
        @if (password.errors) {
          <div class="container-fluid pwd-check radius-4">
            <div class="row">
              <div class="col">
                <span class="title">Votre mot de passe doit contenir:</span>
              </div>
            </div>
            @if (!!password.errors.passwordShouldBeMinimumChars) {
              <div class="row">
                <div class="col">
                  <div class="bullet"></div>
                  <span class="criteria">8 caractères minimum</span>
                </div>
              </div>
            }
            <div class="row">
              @if (!!password.errors.passwordShouldHaveAtLeastOneLowerCaseLetter) {
                <div class="col-md">
                  <div class="bullet"></div>
                  <span class="criteria">1 lettre minuscule</span>
                </div>
              }
              @if (!!password.errors.passwordShouldHaveAtLeastOneDigit) {
                <div class="col-md">
                  <div class="bullet"></div>
                  <span class="criteria">1 chiffre</span>
                </div>
              }
            </div>
            <div class="row">
              @if (!!password.errors.passwordShouldHaveAtLeastOneUpperCaseLetter) {
                <div class="col-md">
                  <div class="bullet"></div>
                  <span class="criteria">1 lettre majuscule</span>
                </div>
              }
              @if (!!password.errors.passwordShouldHaveAtLeastOneSpecialCharacter) {
                <div class="col-md">
                  <div class="bullet"></div>
                  <span class="criteria">1 caractère spécial</span>
                </div>
              }
            </div>
          </div>
        }
        @if (password.invalid && (password.dirty || password.touched)) {
          <span
            class="error">
            {{requiredAlert}} mot de passe valide. Votre mot de passe est trop faible.
          </span>
        }
      </div>
      <div class="form-group col-12">
        <label for="confirmPassword" class="required">Confirmer votre mot de passe</label>
        <input type="password"
          id="confirmPassword"
          name="confirmPassword"
          [formControl]="confirmPassword"
          class="form-control">
        <i class="bar"></i>
        @if (confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)) {
          <span
            class="error">
            Veuillez confirmer votre mot de passe.
          </span>
        }
        @if (confirmPassword.value !== password.value && (confirmPassword.dirty || confirmPassword.touched)) {
          <span
            class="error">
            Les mots de passe ne sont pas identiques.
          </span>
        }
      </div>
    </div>
    <div class="content-mentions">
      <p>
        Les informations portant un astérisque (*) sont obligatoires sur Délice éternel
        {{'COMPANY.NAME' | translate}},
        responsable de traitement, pour répondre à votre demande. En application de la loi Informatique et Libertés
        du 6 janvier 1978 modifiée, vous disposez d’un droit d’accès, de rectification ou d’effacement des données
        vous concernant, et de décider du sort de celles-ci, post-mortem. Vous disposez également d’un droit de vous
        opposer au traitement pour motifs légitimes, de limiter le traitement dont vous faites l’objet et d’un droit
        à la portabilité des données personnelles dans les limites fixées par la loi. Vous disposez enfin de la
        possibilité de vous opposer, à tout moment et sans frais, à la prospection commerciale, y compris lorsque
        celle-ci est réalisée de manière ciblée. Ces droits peuvent être exercés, en justifiant de votre identité,
        par mail à
        <a href="mailto:delice.eternel.gabon@gmail.com">delice.eternel.gabon&#64;gmail.com</a>
        ou juste nous laisser un message sur le site
      </p>
    </div>
    @if (!loading) {
      <button
        type="submit"
        class="btn-suivant btn-primaire-h40 col-md-12"
        [disabled]="sendButtonState()">
        {{submitButtonText}}
      </button>
    }
    @if (loading) {
      <button class="btn-spinner btn-primaire-h40 col-md-12" disabled type="button">
        <i class="fa fa-spinner animate rotation"></i>
      </button>
    }
  </form>
  @if (retrieveUserError) {
    <div class="error-alert">
      <div class="alert alert-danger">
        Une erreur est survenue lors de la récupération de l'utilisateur.
        Veuillez contacter votre administrateur.
      </div>
    </div>
  }
  @if (success) {
    <div class="success-alert">
      <div class="alert alert-success">
        Nous venons de vous envoyer un e-mail avec un lien de confirmation.
        Merci de vérifier votre boite mail et de cliquer sur le lien.
      </div>
    </div>
  }
  <div class="app-auth-divider">
    <span>Déjà client?</span>
  </div>
  <button routerLink="/auth/signin" class="btn-seconnecter btn-secondaire-h40">
    Se connecter
  </button>
</div>
